import { Id, NotificationView } from "../../types";
import { RootState } from "../store";

export const selectIsSignedIn = (state: RootState): boolean =>
  state.user.user !== undefined;

export const selectFriends = (state: RootState): Id[] | undefined =>
  state.user.friends;

export const selectNotifications = (
  state: RootState,
): NotificationView[] | undefined => state.user.notifications;
